import { render, staticRenderFns } from "./GTextLink.vue?vue&type=template&id=5c50df94&scoped=true&"
import script from "./GTextLink.vue?vue&type=script&lang=ts&"
export * from "./GTextLink.vue?vue&type=script&lang=ts&"
import style0 from "./GTextLink.vue?vue&type=style&index=0&id=5c50df94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c50df94",
  null
  
)

export default component.exports